import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  colors,
  Container,
  DialogContentText,
  FormControlLabel,
  Grid,
  IconButton,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Row, Col, Spinner } from "react-bootstrap";
import API from "../../../../network/dashboardAPI";
import moment from "moment";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TablePagination,
} from "@material-ui/core";
import {
  Label,
  ListAlt,
  PermContactCalendar,
  ShoppingBasket,
  ShoppingCart,
} from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import { baseUrl } from "../../../../constants/Constant";
import { backgroundColor } from "styled-system";
import DeleteIcon from "@material-ui/icons/Delete";
import DateTimePicker from "react-datetime";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const StoreSlotSettingIds = () => {
  /**
   */
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [dialogImgOpen, setDialogImgOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [state, setState] = useState(true);
  const [stopAccept, setStopAccept] = useState(false);
  const [totalAccept, setTotalAccept] = useState(0);
  const [autoGenerate, setAutoGenerate] = useState(false);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState("");
  const [slotId, setSlotId] = useState(null);
  const [list, setList] = useState([]);
  const [type, setType] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const handleChange = (event) => {
    setState(event.target.checked);
  };

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const reset = () => {
    setSlotId(null);
    setDate("");
    setState("");
    setEndDate("");
    setStopAccept(false);
    setAutoGenerate(false);
    setTotalAccept(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value));
  };

  const formatDate = (date) => moment(date).format("YYYY-MM-DD HH:mm:ss");
  const changeDate = (date, field) => {
    let newDate = formatDate(date);
    switch (field) {
      case "start_date":
	      setDate(moment(newDate).format("YYYY-MM-DD"));
        return setStartDate(newDate);
      case "end_date":
        return setEndDate(newDate);
      case "date":
        return setDate(moment(date).format("YYYY-MM-DD"));
      default:
        return;
    }
  };

  const handleClickSetup = (type, data = null) => {
    setOpen(!open);
    switch (type) {
      case "update": {
        setType("Update");
        setStartDate(formatDate(data.start_time));
        setEndDate(formatDate(data.end_time));
        setDate(moment(data?.Date).format("YYYY-MM-DD"));
        setStopAccept(data?.stop_accepting_orders === 0 ? false : true);
        setTotalAccept(data?.total_orders_to_accept);
        setAutoGenerate(data?.is_slot_auto_generated === 0 ? false : true);
        setSlotId(data?.slot_id);
        break;
      }
      default: {
        setType("Create");
        break;
      }
    }
  };
  const clodeModal = () => {
    reset();
    setOpen(false);
  };
  const getStoreOngoingSlot = async () => {
    setLoading(true);
    let body = {
      page: page,
      limit: rowsPerPage,
      store_id: 1,
    };
    if (startDateFilter) {
      body.start_date = startDateFilter;
    }
    if (endDateFilter) {
      body.end_date = endDateFilter;
    }
    await API.getOngoingSlot(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setList(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching ongoing slots:", error); // Handle errors
      });
  };
  const stopAcceptOrder = async (data, stop, type, i = "normal") => {
    let body = {
      slot_id: i == "normal" ? [data.slot_id] : selected,
    };
    if (type === "stop_accepting_orders") {
      body.stop_accepting_orders = stop;
    }
    if (type === "slot_expired") {
      body.slot_expired = stop;
    }
    await API.stopAcceptOrder(body)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          getStoreOngoingSlot();
        }
      })
      .catch((error) => {
        console.error("Error fetching ongoing slots:", error); // Handle errors
      });
  };
  const createStoreOngoingSlot = async () => {
	  if (
		  !_.isEmpty(startDate) &&
		  !_.isEmpty(endDate) &&
		  !_.isEmpty(date)
	  ) {
      await API.createOngoingSlot({
        slot_id: slotId,
        start_time: startDate,
        end_time: endDate,
        store_id: 1,
	      Date: date,
        total_orders_to_accept: totalAccept,
        slot_expired: 0,
        stop_accepting_orders: stopAccept,
        is_slot_auto_generated: autoGenerate ? 1 : 0,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.success) {
            getStoreOngoingSlot();
            setOpen(!open);
          } else {
            console.error("Update failed:", data.message);
          }
        })
        .catch((error) => {
          console.error("Error updating ongoing slot:", error);
        });
    } else {
      console.error("Required fields are empty.");
    }
  };
  const updateStoreOngoingSlot = async () => {
    if (
      slotId &&
      !_.isEmpty(startDate) &&
      !_.isEmpty(endDate) &&
      !_.isEmpty(date)
    ) {
      await API.updateOngoingSlot({
        slot_id: slotId,
        start_time: startDate,
        end_time: endDate,
        store_id: 1,
	      Date: date,
        total_orders_to_accept: totalAccept,
        slot_expired: 0,
        stop_accepting_orders: stopAccept ? 1 : 0,
        is_slot_auto_generated: autoGenerate ? 1 : 0,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.success) {
            getStoreOngoingSlot();
            setOpen(!open);
          } else {
            console.error("Update failed:", data.message);
          }
        })
        .catch((error) => {
          console.error("Error updating ongoing slot:", error);
        });
    } else {
      console.error("Required fields are empty.");
    }
  };

  const filter = (date, type) => {
    switch (type) {
      case "start_date":
        return setStartDateFilter(formatDate(date));
      default:
        return setEndDateFilter(formatDate(date));
    }
  };
  const clearFilter = () => {
    setPage(0);
    setStartDateFilter("");
    setEndDateFilter("");
  };

  const [confirmModal, setConfirmModal] = useState(false);
  const handleDelete = (slot_id, type = "normal") => {
    setConfirmModal(!confirmModal);
    switch (type) {
      case "bulk":
        return setSlotId(selected);
      default:
        return setSlotId([slot_id]);
    }
  };
  const deleteSlot = async () => {
    if (slotId) {
      await API.deleteOngoingSlot({ slot_id: slotId, store_id: 1 })
        .then((res) => res.json())
        .then(async (res) => {
          if (res.success) {
            await getStoreOngoingSlot();
            setConfirmModal(false);
          }
        });
    }
  };

  const [selected, setSelected] = useState([]);

  // Handle row selection
  const handleClick = (event, slotId) => {
    const selectedIndex = selected.indexOf(slotId);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, slotId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  // Handle select all click
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.data.map((n) => n.slot_id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    getStoreOngoingSlot();
  }, [startDateFilter, endDateFilter, page, rowsPerPage]);
  
  return (
    <Box component="div" m={1}>
      <Paper className="p-2">
        <Typography className="pl-4 font-bold" variant="h6">
          Store OngoingSlots
        </Typography>
        <Grid container spacing={1} className="my-2 pl-4">
          <Grid item sm={5}>
            <Button
              onClick={() => handleClickSetup("create")}
              variant="contained"
              color="primary"
            >
              <AddIcon /> Create Slot
            </Button>
          </Grid>
          <Grid item sm={3}>
            <TextField
              fullWidth
              id="start_date"
              label="Start Date"
              type="datetime-local"
              value={startDateFilter}
              // className={classes.textField}
              onChange={(e) => filter(e.target.value, "start_date")}
              variant="standard"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <TextField
              fullWidth
              id="end_date"
              label="End Date"
              type="datetime-local"
              value={endDateFilter}
              // className={classes.textField}
              onChange={(e) => filter(e.target.value, "end_date")}
              variant="standard"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          {/* <Grid item sm={1}>
            <CloseIcon onClick={() => clearFilter()} />
          </Grid> */}
        </Grid>
        {selected.length > 0 && (
          <Grid container spacing={1} className="my-2 pl-4">
            <Grid item sm={3}>
              <Button
                fullWidth
                onClick={() =>
                  stopAcceptOrder(1, 1, "stop_accepting_orders", "bulks")
                }
                variant="contained"
                // color="primary"
                style={{backgroundColor:colors.green[500]}}
              >
                Stop Accept Orders
              </Button>
            </Grid>
            <Grid item sm={3}>
              <Button
                fullWidth
                onClick={() =>
                  stopAcceptOrder(0, 0, "stop_accepting_orders", "bulks")
                }
                variant="contained"
                // color="primary"
                style={{backgroundColor:colors.lightBlue[500]}}
              >
                Resume Accept Orders
              </Button>
            </Grid>
            <Grid item sm={2}>
              <Button
                fullWidth
                onClick={() => stopAcceptOrder(1, 1, "slot_expired", "bulks")}
                variant="contained"
                // color="default"
                style={{backgroundColor:colors.red[500]}}
              >
                Set To Expired
              </Button>
            </Grid>
            <Grid item sm={2}>
              <Button
                fullWidth
                onClick={() => stopAcceptOrder(0, 0, "slot_expired", "bulks")}
                variant="contained"
                color="default"
              >
                Set To Active
              </Button>
            </Grid>
            <Grid item sm={2}>
              <Button
                fullWidth
                onClick={() => handleDelete(1, "bulk")}
                variant="contained"
                color="secondary"
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        )}
        <Container>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={
                        list.data?.length > 0 &&
                        selected?.length === list.data?.length
                      }
                      onChange={handleSelectAllClick}
                      inputProps={{ "aria-label": "select all items" }}
                    />
                  </TableCell>
                  <TableCell component="th">Slot ID</TableCell>
                  <TableCell component="th">Start Time</TableCell>
                  <TableCell component="th">End Time</TableCell>
                  <TableCell component="th">Total Accept Order</TableCell>
                  <TableCell component="th" align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: "100px" }}
                      >
                        <Grid item>
                          <CircularProgress size={40} color="primary" />
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ) : list.data.length ? (
                  list.data.map((item) => {
                    const isItemSelected =
                      selected.indexOf(item.slot_id) !== -1;
                    return (
                      <TableRow
                        style={{
                          ...(item.stop_accepting_orders === 1 && {
                            backgroundColor: "#ef9a9a",
                          }),
                          ...(item.slot_expired == 1 && {
                            backgroundColor: "#C0BFBFB9",
                          }),
                        }}
                        key={1}
                        hover
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            onChange={(event) =>
                              handleClick(event, item.slot_id)
                            }
                            inputProps={{ "aria-labelledby": item.slot_id }}
                          />
                        </TableCell>

                        <TableCell>{item.slot_id}</TableCell>
                        <TableCell>{formatDate(item.start_time)}</TableCell>
                        <TableCell>{formatDate(item.end_time)}</TableCell>
                        <TableCell>{item.total_orders_to_accept}</TableCell>
                        <TableCell align="center">
                          <div className="display-flex">
                            <Tooltip title="stop accepted orders">
                              <Switch
                                checked={
                                  item.stop_accepting_orders == 0 ? true : false
                                }
                                onChange={() =>
                                  stopAcceptOrder(
                                    item,
                                    item.stop_accepting_orders == 0 ? 1 : 0,
                                    "stop_accepting_orders"
                                  )
                                }
                                color="primary"
                                name="checkedB"
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                              />
                            </Tooltip>
                            <Button
                              variant="contained"
                              onClick={() =>
                                stopAcceptOrder(
                                  item,
                                  item.slot_expired == 0 ? 1 : 0,
                                  "slot_expired"
                                )
                              }
                              color={
                                item.slot_expired == 0 ? "primary" : "secondary"
                              }
                            >
                              {item.slot_expired == 0
                                ? "No Expired"
                                : "Expired"}
                            </Button>
                            <IconButton
                              onClick={() => handleClickSetup("update", item)}
                              aria-label="edit"
                            >
                              <EditIcon style={{ color: colors.blue[600] }} />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleDelete(item.slot_id)}
                            >
                              <DeleteIcon style={{ color: colors.red[600] }} />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={list.total}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Container>
      </Paper>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={clodeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Setup Store Ongoing Slot"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <TextField
                fullWidth
                id="start_date"
                label="Start Date"
                type="datetime-local"
                value={startDate}
                // className={classes.textField}
                onChange={(e) => changeDate(e.target.value, "start_date")}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                fullWidth
                id="end_date"
                label="End Date"
                type="datetime-local"
                value={endDate}
                onChange={(e) => changeDate(e.target.value, "end_date")}
                // className={classes.textField}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <TextField
                fullWidth
                value={totalAccept}
                onChange={(e) => setTotalAccept(e.target.value)}
                type="number"
                id="outlined-basic"
                label="Total Accept Order"
                variant="outlined"
              />
            </Grid>
            <Grid item sm={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stopAccept}
                    onChange={(e) => setStopAccept(e.target.checked)}
                    name="checked"
                    color="primary"
                  />
                }
                label="Stop Accepting Orders"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={autoGenerate}
                    onChange={(e) => setAutoGenerate(e.target.checked)}
                    name="checked"
                    color="primary"
                  />
                }
                label="Is Slot Auto Generated"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={clodeModal} color="secondary">
            Close
          </Button>
          {type == "Create" ? (
            <Button onClick={() => createStoreOngoingSlot()} color="primary">
              {type}
            </Button>
          ) : (
            <Button onClick={() => updateStoreOngoingSlot()} color="primary">
              {type}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDelete} // Change this to handle modal close without deleting
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          {"Delete Slot Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to delete this slot? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} color="secondary">
            Close
          </Button>
          <Button onClick={deleteSlot} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StoreSlotSettingIds;
